import React from 'react';
import { MenuItem } from '@material-ui/core';

const SelectOnTabMenuItem = React.forwardRef((props, ref) => {
  const { 'data-value': valueForEvent, value, onClick, ...other } = props;
  const handleKeyDown = event => {
    if (event.key === 'Tab') {
      event.persist();
      // Getting the value from the "data-value" prop is necessary
      // due to the manner in which Material-UI clones the MenuItem during
      // display of the Select
      event.target = { value: valueForEvent };
      onClick(event);
    }
  };
  return (
    <MenuItem
      ref={ref}
      value={value}
      onKeyDown={handleKeyDown}
      onClick={onClick}
      {...other}
    />
  );
});

export default SelectOnTabMenuItem;
